<template>
  <div class="zj-layout-main-content bgcolor scrollable" style="overflow: auto">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="110px"
      v-loading="loading"
      :element-loading-text="loadingText"
    >
      <zj-layout-container>
        <zj-layout-header>
          <div class="listtitle">投诉详情</div>
        </zj-layout-header>
      </zj-layout-container>
      <!-- prop="ResourceName" -->
      <zj-layout-main>
        <el-form
          ref="form"
          :model="data"
          :rules="rules"
          label-width="16rem"
          style="width: 80%"
        >
          <el-row v-if="addShow">
            <el-col :span="12">
              <el-form-item label="投诉人" prop="ComplainUser">
                <el-input
                  v-model="data.ComplainUser"
                  :disabled="basicInfoDisabled"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系电话" prop="ContactTel">
                <el-input
                  v-model="data.ContactTel"
                  :disabled="basicInfoDisabled"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="addShow">
            <el-col :span="12">
              <el-form-item label="投诉来源" prop="ComplaintSource">
                <el-select
                  v-model="data.ComplaintSource"
                  placeholder="请选择"
                  :disabled="basicInfoDisabled"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in ComplaintSourceArr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="投诉对象" prop="BeComplained">
                <el-input
                  v-model="data.BeComplained"
                  :disabled="basicInfoDisabled"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="addShow">
            <el-col :span="12">
              <el-form-item label="投诉时间" prop="ComplaintTime">
                <el-date-picker
                  type="datetime"
                  style="width: 100%"
                  placeholder="选择日期"
                  v-model="data.ComplaintTime"
                  v-bind:disabled="basicInfoDisabled"
                  format="yyyy-MM-dd HH:mm"
                  :clearable="false"
                  :picker-options="complaintTimeOption"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="投诉地点" prop="ComplaintPlace">
                <el-input
                  v-model="data.ComplaintPlace"
                  :disabled="basicInfoDisabled"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="addShow">
            <el-col :span="12">
              <el-form-item label="投诉部门" prop="ComplaintDepartmentId">
                <el-select
                  v-model="data.ComplaintDepartmentId"
                  :disabled="basicInfoDisabled"
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in ComplaintDepartments"
                    :key="item.OrgId"
                    :label="item.OrgName"
                    :value="item.OrgId"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="addShow">
            <el-col :span="24">
              <el-form-item label="投诉类型" prop="ComplaintSubType">
                <el-radio-group
                  v-model="data.ComplaintSubType"
                  :disabled="basicInfoDisabled"
                >
                  <el-radio :label="1">景区投诉</el-radio>
                  <el-radio :label="2">环境投诉</el-radio>
                  <el-radio :label="3">服务投诉</el-radio>
                  <el-radio :label="4">物价投诉</el-radio>
                  <el-radio :label="5">其他投诉</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="addShow">
            <el-col :span="24">
              <el-form-item label="投诉内容" prop="Content">
                <el-input
                  v-model="data.Content"
                  :disabled="basicInfoDisabled"
                  type="textarea"
                  :autosize="{ minRows: 2 }"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="addShow">
            <el-col :span="12">
              <el-form-item label="投诉资料">
                <el-upload
                  class="upload-demo"
                  :http-request="httpRequest"
                  :data="uploadData"
                  :show-file-list="true"
                  :file-list="fileList"
                  :before-upload="beforeupload"
                  :on-success="uploadsuccess"
                  :on-progress="uploadProgress"
                  :on-error="uploadError"
                  :on-preview="handlePreview"
                >
                  <el-button
                    size="mini"
                    style="width: 8rem"
                    :disabled="basicInfoDisabled"
                    >上传</el-button
                  >
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            v-if="
              acceptedShow || notAcceptedShow || processedShow || caseClosedShow
            "
          >
            <el-col :span="23" :offset="1"><el-divider></el-divider></el-col
          ></el-row>

          <!-- <el-row style="margin-top: 20px">
            <el-col :span="12">
              <el-form-item label="受理人" prop="AcceptUser">
                <el-input
                  v-model="data.AcceptUser"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="受理时间" prop="AcceptTime">
                <el-date-picker
                  type="datetime"
                  style="width: 100%"
                  placeholder="选择日期"
                  v-model="data.AcceptTime"
                  v-bind:disabled="true"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row> -->
          <el-row style="margin-top: 20px">
            <!-- <el-col :span="12">
              <el-form-item label="处理人" prop="DealUser">
                <el-input
                  v-model="data.DealUser"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col> -->
            <el-col
              :span="12"
              v-if="
                acceptedShow ||
                notAcceptedShow ||
                processedShow ||
                caseClosedShow
              "
            >
              <el-form-item label="处理时间" prop="DealTime">
                <el-date-picker
                  type="date"
                  :clearable="false"
                  style="width: 100%"
                  placeholder="选择日期"
                  v-model="data.DealTime"
                  v-bind:disabled="notAcceptedDisabled || processedDisabled"
                  :picker-options="dealTimeOption"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row>
            <el-col :span="12">
              <el-form-item label="结案人" prop="FinishUser">
                <el-input
                  v-model="data.FinishUser"
                  :disabled="!IsEdit"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="结案时间" prop="FinishTime">
                <el-date-picker
                  type="datetime"
                  style="width: 100%"
                  placeholder="选择日期"
                  v-model="data.FinishTime"
                  v-bind:disabled="true"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row> -->
          <el-row>
            <el-col
              :span="24"
              v-if="acceptedShow || processedShow || caseClosedShow"
            >
              <el-form-item label="处理结果" prop="DealResult">
                <el-input
                  v-model="data.DealResult"
                  :disabled="notAcceptedDisabled || processedDisabled"
                  type="textarea"
                  :autosize="{ minRows: 2 }"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="notAcceptedShow">
            <el-col :span="24">
              <el-form-item label="不受理原因" prop="NotAcceptReason">
                <el-input
                  v-model="data.NotAcceptReason"
                  :disabled="notAcceptedDisabled"
                  type="textarea"
                  :autosize="{ minRows: 2 }"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="processedShow || caseClosedShow">
            <el-col :span="24">
              <el-form-item label="游客反馈" prop="TouristFeedback">
                <el-radio-group
                  v-model="data.TouristFeedback"
                  :disabled="notAcceptedDisabled"
                >
                  <el-radio :label="1">非常满意</el-radio>
                  <el-radio :label="2">满意</el-radio>
                  <el-radio :label="3">一般</el-radio>
                  <el-radio :label="4">不满意</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="processedShow || caseClosedShow">
            <el-col :span="24">
              <el-form-item label="游客意见" prop="TouristOption">
                <el-input
                  v-model="data.TouristOption"
                  :disabled="notAcceptedDisabled"
                  type="textarea"
                  :autosize="{ minRows: 2 }"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="processedShow || caseClosedShow">
            <el-col :span="24">
              <el-form-item label="备注" prop="Memo">
                <el-input
                  v-model="data.Memo"
                  :disabled="notAcceptedDisabled"
                  type="textarea"
                  :autosize="{ minRows: 2 }"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="caseClosedShow">
            <el-col :span="24">
              <el-form-item label="结案说明" prop="FinishDesc">
                <el-input
                  v-model="data.FinishDesc"
                  :disabled="notAcceptedDisabled"
                  type="textarea"
                  :autosize="{ minRows: 2 }"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </zj-layout-main>
      <el-form-item class="right" style="width: 134rem">
        <el-button type="primary" @click="noAccept" v-if="toBeAcceptedShow"
          >不受理</el-button
        >
        <el-button
          type="primary"
          @click="saveForm('accept')"
          v-if="toBeAcceptedShow"
          >受理</el-button
        >
        <el-button type="primary" @click="saveForm('deal')" v-if="acceptedShow"
          >处理</el-button
        >
        <el-button type="primary" @click="finish" v-if="processedShow"
          >结案</el-button
        >
        <el-button
          type="primary"
          @click="saveForm('add')"
          :disabled="!IsEdit"
          v-if="IsEdit"
          >保存</el-button
        >
        <el-button @click="onBack()">返回</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      title="原因说明"
      :visible.sync="dialogVisible"
      width="35%"
      :before-close="handleClose"
      :append-to-body="true"
      style="text-align: left"
      :destroy-on-close="true"
      ><no-acceptance-view
        :data="data"
        @clickCancel="handleDialogCancel"
      ></no-acceptance-view>
    </el-dialog>
    <el-dialog
      title="结案说明"
      :visible.sync="finishDialogVisible"
      width="35%"
      :before-close="handleClose"
      :append-to-body="true"
      style="text-align: left"
      :destroy-on-close="true"
      ><complaint-finish
        :data="data"
        @clickCancel="handleFinishDialogCancel"
      ></complaint-finish>
    </el-dialog>
  </div>
</template>
<script>
import MyApis from "../../../apis";
import Apis from "../../../../../../api";
import ZJApp from "../../../../../app";
import NoAcceptanceView from "./NoAcceptanceView.vue";
import ComplaintFinish from "./ComplaintFinish.vue";
import permissionsApi from "../../../../../../request/permissionsApi";

export default {
  name: "ComplaintManagerInfo",
  controller: "UI",
  action: "ComplaintManagerInfo",
  components: {
    NoAcceptanceView,
    ComplaintFinish,
  },
  data() {
    let validateContactTel = (rule, value, callback) => {
      if (
        !value.match(/^[1][0-9][0-9]{9}/) &&
        !value.match(/^[0-9]{6,8}/) &&
        !value.match(/^[0-9]{2,4}(-)?[0-9]{5,10}$/)
      ) {
        callback(new Error("联系电话的格式错误。请输入手机号或座机号！"));
      } else {
        callback();
      }
    };
    return {
      data: {
        TouristFeedback: 0,
        ComplaintTime: new Date(),
        DealTime: new Date(),
      },
      ComplaintSource: "",
      ComplaintSourceArr: [
        { value: 6, label: "电话" },
        { value: 7, label: "其他" },
      ],
      ComplaintStatus: "",
      ComplaintStatusArr: [
        { value: 1, label: "待受理" },
        { value: 2, label: "已受理" },
        { value: 3, label: "不受理" },
        { value: 4, label: "已处理" },
        { value: 5, label: "已结案" },
      ],
      ComplaintSubType: "",
      ComplaintSubTypeArr: [
        { value: 1, label: "景区投诉" },
        { value: 2, label: "环境投诉" },
        { value: 3, label: "服务投诉" },
        { value: 4, label: "物价投诉" },
        { value: 5, label: "其他投诉" },
      ],
      ComplaintDepartmentId: "",
      ComplaintDepartments: [],
      loading: false,
      loadingText: "加载中...",
      IsEdit: false,
      uploadData: {
        module: "ComplaintManager", //模块名
        submodule: "", //子模块
        assocID: "", //业务ID
        uploader: ZJApp.ZJUser.current.UserName, //上传人
        folder: "", //上传目录，服务器按如下格式拼装：/{module}/{submodule}/{folder}
        ext1: "", //扩展字段 1
        ext2: "", //扩展字段 2
        ext3: 0, //扩展字段 3
      },
      fileList: [],
      complaintTimeOption: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        },
      },
      dealTimeOption: {
        disabledDate: (time) => {
          if (this.data.ComplaintTime) {
            return (
              Date.now() - 8.64e6 <
              time.getTime() <
              new Date(this.data.ComplaintTime).getTime()
            );
          }
        },
      },
      rules: {
        ComplainUser: [
          { required: true, message: "请输入投诉人", trigger: "blur" },
        ],
        ContactTel: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
          { validator: validateContactTel, trigger: "blur" },
        ],
        BeComplained: [
          { required: true, message: "请输入投诉对象", trigger: "blur" },
        ],
        ComplaintPlace: [
          { required: true, message: "请输入投诉地点", trigger: "blur" },
        ],
        ComplaintSource: [
          { required: true, message: "请选择投诉来源", trigger: "change" },
        ],
        ComplaintDepartmentId: [
          { required: true, message: "请选择投诉部门", trigger: "change" },
        ],
        Content: [
          { required: true, message: "请输入投诉内容", trigger: "blur" },
        ],
        ComplaintSubType: [
          { required: true, message: "请选择投诉类型", trigger: "change" },
        ],
        DealResult: [
          { required: true, message: "请输入处理结果", trigger: "blur" },
        ],
        TouristFeedback: [
          { required: true, message: "请选择游客反馈", trigger: "change" },
        ],
      },
      uuid:
        this.$route.query.type == "edit"
          ? this.$route.query.InfoId
          : ZJApp.ZJUtils.uuid(),
      addShow: this.$route.query.formShow == "accept",
      dialogVisible: false,
      finishDialogVisible: false,
      toBeAcceptedShow: false,
      acceptedShow: false,
      notAcceptedShow: false,
      processedShow: false,
      caseClosedShow: false,
      basicInfoDisabled: false, //投诉基本信息禁用
      notAcceptedDisabled: false,
      processedDisabled: false,
    };
  },
  created: function () {
    if (this.$route.query.InfoId) {
      this.getFileList();
      this.init();
    }
    if (this.$route.query.type == "edit") {
      this.IsEdit = false;
    } else {
      this.IsEdit = true;
    }
  },
  mounted() {
    if (this.CNF("app.isBiaoZhunHua")) {
      this.getBJDepartments();
    } else {
      this.getTopDepartments();
    }
  },
  watch: {
    $route: function () {
      if (this.$route.query.InfoId) {
        this.getFileList();
      }
    },
  },
  computed: {
    httpRequest() {
      return ZJApp.ZJApis.ZJUploader.upload;
    },
  },
  methods: {
    //根据当前投诉信息的状态判断是否显示
    init() {
      this.data.DealTime =
        this.data.DealTime.Year > 1 ? this.data.DealTime : new Date();
      switch (this.data.ComplaintStatus) {
        case 1: //待受理
          this.toBeAcceptedShow = true;
          break;
        case 2: //已受理
          this.acceptedShow = true;
          this.basicInfoDisabled = true;
          break;
        case 3: //不受理
          this.notAcceptedShow = true;
          this.basicInfoDisabled = true;
          this.notAcceptedDisabled = true;
          break;
        case 4: //已处理
          this.processedShow = true;
          this.basicInfoDisabled = true;
          this.processedDisabled = true;
          break;
        case 5: //已结案
          this.caseClosedShow = true;
          this.basicInfoDisabled = true;
          this.processedDisabled = true;
          break;
      }
    },

    //北京统一登录时获取北京所有部门
    getBJDepartments() {
      permissionsApi
        .findOrganizationTree({ projectCode: this.CNF("app.perProjectCode") }).then((res) => {
        if (res.code == 0) {
          if (res.data.length > 0) {
            const departs = this.flattenTree(res.data);

            this.ComplaintDepartments = departs.map((item) => {
              return { OrgId: item.code, OrgName: item.name };
            });
            console.log("this.user",this.user);

            this.ComplaintDepartments = this.user.Departments;

            // const IsAcceptRole = this.user.Roles.filter((r) => {
            //   return r.indexOf("投诉受理岗") >= 0;
            // });

            // if (
            //   this.user.Departments != null &&
            //   this.user.Departments.length > 0 &&
            //   IsAcceptRole.length <= 0
            // ) {
            //   this.ComplaintDepartments = this.user.Departments;
            // }
          }
        } else {
          this.errmsg(res.msg);
        }
      });
    },
    flattenTree(nodes) {
      var r = [];
      if (Array.isArray(nodes)) {
        for (var i = 0, l = nodes.length; i < l; i++) {
          r.push(nodes[i]); // 取每项数据放入一个新数组
          if (
            Array.isArray(nodes[i]["children"]) &&
            nodes[i]["children"].length > 0
          )
            // 若存在children则递归调用，把数据拼接到新数组中，并且删除该children
            r = r.concat(this.flattenTree(nodes[i]["children"]));
          delete nodes[i]["children"];
        }
      }
      return r;
    },

    //绑定部门信息
    getTopDepartments() {
      new Apis.OrgApi()
        .FindByConditions({ OrgCode: this.config.app.org_code })
        .then((r) => {
          r = r.data.Data;
          if (r != null && r.length > 0) {
            this.getDepartments(r[0].OrgId);
          }
          console.log(r);
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    getDepartments(OrgId) {
      new Apis.OrgApi()
        .FindByConditions({ ParentOrgId: OrgId })
        .then((r) => {
          r = r.data.Data;
          this.ComplaintDepartments = r;
          if (
            this.user.Departments != null &&
            this.user.Departments.length > 0 &&
            this.user.Role[0].data.Data.RoleName != "投诉受理岗"
          ) {
            this.ComplaintDepartments = this.ComplaintDepartments.filter(
              (p) => {
                return p.OrgId == this.user.Departments[0].OrgId;
              }
            );
          }
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    //获取上传附件
    getFileList() {
      let InfoId = this.$route.query.InfoId;
      if (InfoId) {
        const searchInfo = { AssocID: InfoId, PageSize: 100, PageIndex: 1 };
        this.data = this.$route.query.Info;
        this.loading = true;
        new Apis.FileApi()
          .GetFileList(searchInfo)
          .then((r) => {
            r = r.data.Data;
            this.fileList = r.FileList.map((item) => ({
              name: item.FileName,
              url: item.DownloadPath + "?d=1",
            }));
            this.loading = false;
          })
          .catch((e) => {
            this.loading = false;
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    handleDialogCancel() {
      this.dialogVisible = false;
    },
    noAccept() {
      this.dialogVisible = true;
    },
    //结案
    handleFinishDialogCancel() {
      this.finishDialogVisible = false;
    },
    finish() {
      this.finishDialogVisible = true;
    },
    //保存
    saveForm(value) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.saveData(value);
        } else {
          return false;
        }
      });
    },
    saveData(value) {
      this.loading = true;
      this.loadingText = "保存中...";
      let RoleName = "";
      const ComplaintDepartmentName = this.ComplaintDepartments.filter(
        (item) => {
          return item.OrgId === this.data.ComplaintDepartmentId;
        }
      );
      this.data.ComplaintDepartment = ComplaintDepartmentName[0].OrgName;
      if (this.$route.query.type == "edit") {
        //编辑
        if (value == "accept") {
          this.data.AcceptUser = ZJApp.ZJUser.current.UserName;
          this.data.AcceptTime = new Date();
          this.data.ComplaintStatus = 2;
          RoleName = "投诉承办岗";
          this.logInfo.ActionName = "投诉受理";
          this.logInfo.LogMessage = "投诉受理";
        }
        if (value == "deal") {
          this.data.DealUser = ZJApp.ZJUser.current.UserName;
          this.data.DealTime = new Date();
          this.data.ComplaintStatus = 4;
          RoleName = "投诉办结岗";
          this.logInfo.ActionName = "投诉处理";
          this.logInfo.LogMessage = "投诉处理";
        }
        let formAll = JSON.stringify(this.data);
        formAll = JSON.parse(formAll);
        new MyApis.TranResourcesApi()
          .UpdateItem(formAll)
          .then((r) => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！",
            });
            this.loading = false;
            this.logInfo.ModuleName = "投诉系统";
            this.logInfo.PageName = "投诉管理详情";
            this.addOperationLog();
            this.AddSmsSendRecordByDepartmentId(
              this.data.ComplaintDepartmentId,
              RoleName
            );
            // this.$router.go(-1); //返回上一层
          })
          .catch((e) => {
            this.loading = false;
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      } else {
        // 增加
        let formObj = {
          Creater: ZJApp.ZJUser.current.UserName,
          CreateTime: new Date(),
          Modifier: ZJApp.ZJUser.current.UserName,
          ModifyTime: new Date(),
          Id: this.uuid,
          ComplaintStatus: 1, //待受理
          Validity: 1, //新增编辑是1，删除是0
        };
        let formAll = Object.assign(formObj, this.data);
        formAll = JSON.stringify(formAll);
        formAll = JSON.parse(formAll);
        new MyApis.TranResourcesApi()
          .AddItem(formAll)
          .then((r) => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！",
            });
            if (r) {
              this.logInfo.ActionName = "投诉添加";
              this.logInfo.LogMessage = "投诉添加成功";
              this.logInfo.ModuleName = "投诉系统";
              this.logInfo.PageName = "投诉管理详情";
              this.addOperationLog();
              this.AddSmsSendRecordByDepartmentId(
                this.data.ComplaintDepartmentId,
                ""
              );
            }
          })
          .catch((e) => {
            this.loading = false;
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    beforeupload: function () {
      this.uploadData.assocID = this.uuid;
      this.loading = true;
      this.loadingText = "上传中... 0%";
    },
    uploadsuccess: function () {
      this.loading = false;
    },
    uploadError(err) {
      console.error("上传失败: ", err);
      this.errmsg("上传失败: " + err);
      this.loading = false;
    },
    uploadProgress(e) {
      this.loadingText = "上传中... " + parseInt(e.percent) + "%";
    },
    handlePreview(file) {
      console.log(file);
      document.location.href = file.url;
    },
    //根据部门添加发送的短信
    AddSmsSendRecordByDepartmentId(DepartmentId, RoleName) {
      this.GetUsersByOrgId(DepartmentId, RoleName);
      this.loading = false;
      this.$router.go(-1); //返回上一层
    },
    //根据组织部门id获取部门下的人员信息，不包括子部门
    GetUsersByOrgId(DepartmentId, RoleName) {
      new Apis.OrgUserApi()
        .GetUsersByOrgId({ OrgId: DepartmentId })
        .then((r) => {
          r = r.data.Data;
          this.GetUserRole(r, RoleName);
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    //获取用户角色信息
    GetUserRole(users, RoleName) {
      if (users != null && users.length > 0) {
        // let flagcount = 0;
        for (let i = 0; i < users.length; i++) {
          let userList = [];
          new Apis.UserRoleApi()
            .GetByUserId({ UserId: users[i].UserId })
            .then((r) => {
              r = r.data.Data;
              userList = r;
              if (userList != null && userList.length > 0) {
                const userInfo = userList[0];
                let isRoleRight = false;
                let roles = [];
                const that = this;
                this.GetRoles(userInfo.RoleId, function (data) {
                  roles = data;
                  if (roles != null) {
                    isRoleRight = roles.RoleName == RoleName;
                  }
                  if (!isRoleRight) {
                    //角色与RoleName不同 则不发短信，包含RoleName才发短信
                    // continue;
                    return true;
                  }
                  //flagcount = flagcount + 1;
                  const record = {
                    Id: ZJApp.ZJUtils.uuid(),
                    PhoneNo: users[i].Phone,
                    Content: "有新投诉信息，请及时处理",
                    Charset: "GBK",
                    Creater: ZJApp.ZJUser.current.UserName,
                    CreateTime: new Date(),
                    Modifier: ZJApp.ZJUser.current.UserName,
                    ModifyTime: new Date(),
                    SendTime: new Date(),
                    Extends2: users[i].Phone,
                  };
                  console.log("发送短信");
                  that.SendMs(record);
                });
              }
            })
            .catch((e) => {
              console.log(e);
              this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
            });
        }
      }
    },
    //获取rolename
    GetRoles(RoleId, callback) {
      new Apis.RoleApi()
        .GetItemById({ RoleId: RoleId })
        .then((r) => {
          r = r.data.Data;
          callback(r);
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    //发送短信
    SendMs(record) {
      new MyApis.SendSmsApi()
        .SendSms(record)
        .then((r) => {
          r = r.data.Data;
          if (r) {
            this.$message({
              type: "success",
              message: "消息发送成功!",
            });
            this.logInfo.ActionName = "发送短信";
            this.logInfo.LogMessage = "短信发送成功";
            this.logInfo.ModuleName = "投诉系统";
            this.logInfo.PageName = "投诉管理详情";
            this.addOperationLog();
          } else {
            this.$message({
              type: "error",
              message: "消息发送失败!",
            });
          }
          this.loading = false;
        })
        .catch((e) => {
          console.error(e);
          this.$message(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          this.loading = false;
        });
    },
  },
};
</script>
